<!-- 投放公众号 -->
<template>
<div>
	
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<!-- 标题 -->
		<div class="page-title">投放公众号</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 12px 0 0;">
			<div class="screen-box">
				<div class="screen-label">公众号名称</div>
				<a-input v-model="r_gzh_name" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">Appid</div>
				<a-input v-model="r_appid" allowClear placeholder="请输入Appid" style="width: 190px;"/>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">渠道</div>
				<a-select
					showSearch
					style="min-width: 200px"
					placeholder="请选择渠道"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterData.channel_id.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">推广平台</div>
				<a-select
					showSearch
					style="min-width: 200px"
					placeholder="请选择推广平台"
					@change="handleChangeG"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="0">未设置</a-select-option>
					<a-select-option v-for="(value,key) in platformData" :key="key" :value="key">{{value}}</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">管理员</div>
				<a-select
					showSearch
					style="min-width: 200px"
					placeholder="请选择管理员"
					@change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option v-for="(item,index) in filterData.op_id.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">绑定运营公众号</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择"
					@change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
				  >
					<a-select-option value="1">
					  是
					</a-select-option>
					<a-select-option value="2">
					  否
					</a-select-option>
				</a-select>
			</div>
			
			
			<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" class="screen-box">搜索</a-button>

			<a-button class="screen-box" @click="setAdmin" type="primary">批量设置管理员（已选{{selectedData.length}}项）</a-button>
		</div>

	</div>
	</div>
	
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			
			<div  class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':50 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[0].width + 'px',}">
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell"
				:style="{'width':rableTitle[1].width + 'px',}">
					{{rableTitle[1].title}}
				</div>
			</div>
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" v-if="index > 1"
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;" :style="{'height': item.height + 'px'}">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':50 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<!-- ID -->
				<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<!-- 公众号名称 -->
				<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
					{{item.gzh_name}}
				</div>
			</div>
			
			<!-- 渠道 -->
			<div class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.channel_name || "未设置"}}
			</div>
			<!-- APPID -->
			<div class="table-td-cell" @click="tdEdit(item,index,'APPID')" style="color: #62a8ea;cursor: pointer;" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.appid || "未设置"}}
			</div>
			<!-- 微信ID -->
			<div class="table-td-cell" @click="tdEdit(item,index,'微信ID')" style="color: #62a8ea;cursor: pointer;" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.gzh_wechat_id || "未设置"}}
			</div>
			<!-- 原始ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.original_id || "未设置"}}
			</div>
			<!-- 关注页链接 -->
			<div class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				<a-tooltip v-if="item.jump_url" placement="top">
					<template slot="title">
					  <span>{{item.jump_url}}</span>
					</template>
					<div @click="mkUrlCopy(item,1)" style="display: flex;align-items: center;cursor: pointer;">
						关注页链接
						<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
					</div>
				</a-tooltip>
				<div v-else>未设置</div>
			</div>
			<!-- 推广平台 -->
			<div @click="editType(item)" class="table-td-cell" :style="{'width':rableTitle[7].width + 'px'}">
				<div v-if="item.gzh_report_config" style="color: #62a8ea;cursor: pointer;">
					{{item.platform_name}}
				</div>
				<div v-else style="color: #62a8ea;cursor: pointer;">
					未设置(默认巨量)
				</div>
			</div>
			<!-- 推广参数 -->
			<div class="table-td-cell" :style="{'width':rableTitle[8].width + 'px'}">
				<template v-if="item.platform_name.indexOf('腾讯') > -1">
					<a-tooltip placement="top">
						<template slot="title">
						  <span>{{item.tencent_click_url}}</span>
						</template>
						<div @click="txUrlCopy(item)" style="display: flex;align-items: center;cursor: pointer;">
							点击监测链接
							<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
						</div>
					</a-tooltip>
				</template>
				<template v-else-if="item.platform_name.indexOf('微博') > -1">
					<a-tooltip placement="top">
						<template slot="title">
						  <span>{{item.weibo_click_url}}</span>
						</template>
						<div @click="wbUrlCopy(item)" style="display: flex;align-items: center;cursor: pointer;">
							点击监测链接
							<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
						</div>
					</a-tooltip>
				</template>
				<template v-else-if="!item.platform_name || item.platform_name.indexOf('巨量') > -1">
					<a-tooltip placement="top">
						<template slot="title">
						  <span>{{item.mk_click_url}}</span>
						</template>
						<div @click="mkUrlCopy(item,2)" style="display: flex;align-items: center;cursor: pointer;">
							点击监测链接
							<a-icon type="copy" style="font-size: 13px;margin-left: 9px;"/>
						</div>
					</a-tooltip>
				</template>
			</div>
			<!-- 管理员 -->
			<div @click="setAdminShow(item)" class="table-td-cell" :style="{'width':rableTitle[9].width + 'px'}">
				<div v-if="item.gzh_user.length > 0" style="display: flex;align-items: center;cursor: pointer;flex-wrap: wrap;">
					<div v-for="(item,index) in item.gzh_user" :key="index" style="color: #2F88FF;margin: 0 10px 5px 0">
						{{item.admin_name}}
					</div>
				</div>
				<div v-else style="color: #62a8ea;cursor: pointer;">
					未设置
				</div>
			</div>
			<!-- 第三方外键 -->
			<div class="table-td-cell" :style="{'width':rableTitle[10].width + 'px'}">
				{{item.foreign_key}}
			</div>
			<!-- 是否展示 -->
			<div class="table-td-cell" :style="{'width':rableTitle[11].width + 'px'}">
				<!-- {{item.is_show}} -->
				<a-switch @change="tdShowSwitch($event,index)" :checked="!!item.is_show" size="small" checked-children="展示" un-checked-children="关闭" />
			</div>
			<!-- 是否绑定运营公众号 -->
			<div class="table-td-cell" :style="{'width':rableTitle[12].width + 'px'}">
				<!-- {{item.openplatform_id}} -->
				<div v-if="item.openplatform_id == 0" style="background: #edc30e;border-radius: 3px;width: 25px;height: 25px;line-height: 25px;text-align: center;color: #fff;">
					否
				</div>
				<div v-else style="display: flex;align-items: center;">
					<div style="background: #21b978;border-radius: 3px;width: 25px;height: 25px;line-height: 25px;text-align: center;color: #fff;">
						是
					</div>
					<div style="margin-left: 10px;">{{item.openplatform_id}}</div>
				</div>
				
			</div>
			<!-- 操作 -->
			<!-- <div @click="editTable(index,item)" class="table-td-cell" :style="{'width': rableTitle[8].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
				编辑
			</div> -->
		</div>
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: calc(100vh - 65px);width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: calc(100vh - 65px);width: 30px;"></div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': ((body_width - 30) > table_scroll_width)? table_scroll_width: (body_width - 30) + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>

	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 50px;position: sticky;left: 30px;" :style="{'width': body_width - 30 + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" 
			:showTotal="(total, range) => `共 ${total} 条`" 
			:pageSizeOptions="['20','30','50','80','100','150','200','300']"
			 show-quick-jumper show-size-changer @showSizeChange="changeSizeLimit" />
		</div>
	</div>
	
	<!-- 编辑单项的弹窗 -->
	<a-modal
	      :title="`编辑${edit_modal_title}`"
	      :visible="edit_visible"
	      :confirm-loading="confirmLoading"
		  cancelText="取消"
		  okText="确认" 
	      @ok="editModalOk"
	      @cancel="editModalCancel"
		   width="700px"
	    >
		<a-input v-if="edit_modal_title == 'APPID'" v-model="e_appid" placeholder="请输入appid" style="width: 500px;"  />
		
		<a-input v-else-if="edit_modal_title == '微信ID'" v-model="e_wechatid" placeholder="请输入微信ID" style="width: 500px;"  />
		
		<div v-else-if="edit_modal_title == '推广平台'" class="form-cell-box">
			<div class="class-title">推广平台</div>
				
			<a-select :value="e_type_id" style="width: 500px" placeholder="未选择"
			 @change="handleChangeT" allowClear>
				<a-select-option v-for="(value,key) in platformData" :key="key" :value="key">{{value}}</a-select-option>
				<!-- <a-select-option :value="1">百度</a-select-option>
				<a-select-option :value="2">微博</a-select-option>
				<a-select-option :value="3">巨量</a-select-option>
				<a-select-option :value="4">快手</a-select-option>
				<a-select-option :value="5">OPPO</a-select-option> -->
			</a-select>
		</div>
	</a-modal>
	
	<!-- 批量设置管理员 -->
	<a-modal :visible="pl_modal" title="批量设置管理员" okType="primary" width="700px"
	  okText="设置" cancelText="取消"
	  @ok="plOk" @cancel="plCancel" :confirmLoading="pl_loading">
	    <div style="">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 15px;font-size: 15px;">请选择要添加的管理员</div>
				<a-select
					style="min-width: 200px"
					placeholder="请选择管理员"
					@change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					:labelInValue="true"
				  >
					<a-select-option v-for="(item,index) in filterData.op_id.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			<div style="display: flex;flex-wrap: wrap;margin: 15px 0 30px;max-height: 100px;overflow-y: auto;">
				<div style="width: 120px;display: flex;align-items: center;margin-bottom: 7px;" v-for="(item,index) in pl_select_admin" :key="index">
					<div style="margin-right: 15px;">{{item.label}}</div>
					<!-- <div @click="delSelectAdmin(index)" style="color: red;cursor: pointer;">删除</div>\ -->
					<a-icon @click="delSelectAdmin(index)" type="close-circle" />
				</div>
			</div>
			<div style="margin-bottom: 10px;margin-top: 15px;">已选的公众号名称：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 10px;" class="">
					<div style="width: 70px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 100px;">{{item.gzh_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
	
</div>
</template>

<script>
import { putGzhList, putDataMenu, putGzhSetAppid, putGzhSetWechatid, putGzhSetUser, putGzhSetBd, putGzhSetShow, putGzhPlatform } from '@/request/api'
export default {
	name: 'putGzh_',
	components: {
		
	},
	data() {
		return {
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID", width:70, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"公众号名称", width:110, type:"gzh_name", },
				{title:"渠道", width:100, type:"channel_name", },
				{title:"APPID", width:160, type:"appid", },
				{title:"微信ID", width:130, type:"gzh_wechat_id", },
				{title:"原始ID", width:150, type:"original_id", },
				{title:"关注页链接", width:170, type:"jump_url", },
				{title:"推广平台", width:100, type:"gzh_report_config", },
				{title:"推广参数", width:160, type:"mk_click_url", },
				{title:"管理员", width:150, type:"gzh_user", },
				{title:"第三方外键", width:120, type:"foreign_key", },
				// {title:"总投放金额", width:120, type:"total_put_money", },
				// {title:"总充值金额", width:120, type:"total_charge_money", },
				{title:"是否展示", width:90, type:"is_show", },
				{title:"是否绑定运营公众号", width:160, type:"openplatform_id", },
				// {title:"操作", width:80, type:"cz", },
			],
			tableShowData: [],
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_scroll_width: 1000,
			search_button_loading: false,
			
			r_page: 1,
			r_limit: 50,
			table_total: 0,
			
			r_gzh_name: null, // 公众号名称
			r_channel_id: undefined, // 选择渠道
			r_admin_id: undefined, // 管理员
			r_have_auth: undefined, // 是否绑定运营公众号。1为是。2为否
			r_appid: null, // appid
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 筛选条件部分
			filterData: {
				op_id:{
					list: [{}],
				},
				
				media_id:{
					list: [{}],
				},
				channel_id:{
					list: [{}],
				},
				gzh_id:{
					list: [{}],
				},
				
				
			}, // 筛选条件数组
			
			// 单个编辑弹窗
			edit_visible: false, // 编辑弹窗的显示
			edit_modal_title: "", // 编辑弹窗的标题
			confirmLoading: false,
			e_appid: "", // 编辑appid请求需要的参数
			e_wechatid: "", // 编辑微信ID请求需要的参数
			e_id: "", // 编辑请求用的id
			e_type_id: undefined, // 推广平台
			e_req_type_id: "", // 请求用的id
			
			// 批量设置管理员
			pl_modal: false,
			pl_loading: false,
			pl_select_admin: [],
			
			platformData: {}, // 推广平台下拉
			r_channel_plat: null, // 推广平台搜索条件
		}
	},
	mounted(){
		let that = this
		
		that.body_width = document.body.clientWidth - 60 - 50 // 筛选条件大盒子的宽度
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30 + 60
		
		putDataMenu().then(res=>{
			// console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		putGzhPlatform().then(res=>{
			// console.log("推广平台下拉",res);
			that.platformData = res.data.data.list
			
			that.searchButton()
		})
		
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 请选择渠道
		handleChangeA(e){
			this.r_channel_id = e
		},
		// 请选择管理员
		handleChangeB(e){
			this.r_admin_id = e
		},
		// 是否绑定运营公众号
		handleChangeC(e){
			this.r_have_auth = e
		},
		// 批量设置管理员，选择管理员
		handleChangeD(e){
			console.log(e);
			let ttt = true
			this.pl_select_admin.forEach(res=>{
				if(res.key == e.key){
					ttt = false
				}
			})
			if(ttt){
				this.pl_select_admin.push(e)
			}
		},
		// 删除选择的管理员
		delSelectAdmin(index){
			this.pl_select_admin.splice(index,1)
		},
		// 推广平台
		handleChangeG(e){
			this.r_channel_plat = e
		},
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type != '分页'){
				that.selectedData = [] // 已选内容清空
			}
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			putGzhList({
				page: that.r_page,
				limit: that.r_limit,
				
				channel_id: that.r_channel_id,
				admin_id: that.r_admin_id,
				gzh_name: that.r_gzh_name,
				have_auth: that.r_have_auth,
				appid: that.r_appid, // appid
				
				channel_plat: that.r_channel_plat,
			}).then(res=>{
				// console.log("搜索结果",res);
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					let data = res.data.data.data
					that.table_total = res.data.data.total || 0
					data.forEach(res=>{
						res.checked = false // 用于多选和单选
						res.platform_name = ""
						if(res.gzh_report_config){
							if(res.gzh_report_config.bd_report_status == 1){
								res.bd_checked = true
							}
							else {
								res.bd_checked = false
							}
							
							// 动态获取当前的推广平台的名字
							for (let key in that.platformData) {
								if(res.gzh_report_config.type == key){
									res.platform_name = that.platformData[key]
								}
							}
						}
						else {
							res.bd_checked = false
							
						}
					})
					
					if(that.selectedData.length > 0){
						let ccc = true
						let iii = 0 // 用于判断是否全选
						data.forEach(res=>{
							that.selectedData.forEach(res_r=>{
								if(res.id === res_r.id){
									res.checked = true
									ccc = false
									iii = iii + 1
								}
							})	
						})
						console.log("iii",iii)
						if(iii === 20){ // 全选
							that.indeterminate = false
							that.checkAll = true
						}
						else {
							if(ccc){
								that.checkAll = false
								that.indeterminate = false
							}
							else {
								that.checkAll = false
								that.indeterminate = true
							}
						}
						
					}
					else {
						console.log("that.checkAll",that.checkAll)
						that.checkAll = false
						that.indeterminate = false
					}
					
					that.search_button_loading = false
					that.$message.success('搜索成功');
					
					// console.log("data",data);
					that.tableShowData = data
				}
				else {
					that.search_button_loading = false
					that.checkAll = false
					that.indeterminate = false
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false
					})
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			this.r_page = e
			this.searchButton('分页')
		},
		changeSizeLimit(current, e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		// 巨量链接复制
		mkUrlCopy(e,type){
			console.log(e);
			let that = this
			let url = ""
			if(type == 1){ // 关注页链接
				url = e.jump_url
			}
			else if(type == 2){
				url = e.mk_click_url
			}
			else {
				return
			}
			this.$copyText(url).then(res=>{
				that.$message.success('复制成功');
			}).catch(err=>{
				that.$message.error('复制失败');
			})
		},
		// 腾讯链接复制
		txUrlCopy(e){
			let that = this
			this.$copyText(e.tencent_click_url).then(res=>{
				that.$message.success('复制成功');
			}).catch(err=>{
				that.$message.error('复制失败');
			})
		},
		wbUrlCopy(e){
			let that = this
			this.$copyText(e.weibo_click_url).then(res=>{
				that.$message.success('复制成功');
			}).catch(err=>{
				that.$message.error('复制失败');
			})
		},
		// 批量设置管理员
		setAdmin(){
			if(this.selectedData.length > 0){
				this.pl_modal = true
			}
			else {
				this.$message.warning('请先选择内容');
			}
		},
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		// 百度回传
		bdhcSwitch(e,index){
			let that = this
			console.log(e);
			// this.tableShowData[index].bd_checked = e
			putGzhSetBd({
				id: that.tableShowData[index].id
			}).then(res=>{
				console.log("百度回传",res);
				that.$message.success('操作成功');
				that.searchButton()
			})
		},
		// 是否展示
		tdShowSwitch(e,index){
			let that = this
			console.log(e);
			// this.tableShowData[index].bd_checked = e
			putGzhSetShow({
				id: that.tableShowData[index].id
			}).then(res=>{
				console.log("百度回传",res);
				that.$message.success('操作成功');
				that.searchButton()
			})
		},
		// 表格单元格内的编辑按钮
		tdEdit(e,index,type){
			// console.log(e);
			// console.log(index);
			// console.log(type);
			this.e_id = e.id
			if(type == "APPID"){
				this.e_appid = e.appid
			}
			else if(type == "微信ID"){
				this.e_wechatid = e.gzh_wechat_id
			}
			this.edit_modal_title = type
			this.edit_visible = true
		},
		// 编辑弹窗确认按钮
		editModalOk(){
			let that = this
			that.confirmLoading = true
			if(that.edit_modal_title == "APPID"){
				putGzhSetAppid({
					id: that.e_id,
					appid: that.e_appid
				}).then(res=>{
					that.confirmLoading = false
					console.log("编辑APPID",res);
					that.editModalCancel()
					that.$message.success('编辑成功');
					that.searchButton()
				}).catch(err=>{
					that.confirmLoading = false
				})
			}
			else if(that.edit_modal_title == "微信ID"){
				putGzhSetWechatid({
					id: that.e_id,
					wechatid: that.e_wechatid
				}).then(res=>{
					that.confirmLoading = false
					console.log("微信ID",res);
					that.editModalCancel()
					that.$message.success('编辑成功');
					that.searchButton()
				}).catch(err=>{
					that.confirmLoading = false
				})
			}
			else if(that.edit_modal_title == "推广平台"){
				putGzhSetBd({
					id: that.e_req_type_id , // 授权公众号id
					type: that.e_type_id || 0 , // 订单回传平台1=百度，2=微博，3=巨量, 4=快手
				}).then(res=>{
					that.confirmLoading = false
					// console.log("编辑推广平台",res);
					that.editModalCancel()
					if(res.data.code == 401){
						that.$message.error(`错误：${res.data.msg}`);
						return
					}
					if(that.e_type_id == 6){ // 腾讯
						that.$confirm({
							title: '继续完成回传设置',
							icon:"exclamation-circle",
							class:'jlzh',//类名
							okText: "继续完成回传设置",
							cancelText: "取消",
							content: h => <div >请到<span style="font-weight: 600;">【腾讯广告回传设置】</span>页面，继续完成回传设置。</div>,
							onOk() {
							  // console.log('OK');
							  const { href } = that.$router.resolve('/TxAdvHc')
							  window.open(href, '_blank');
							  that.searchButton()
							},
							onCancel() {
							  console.log('Cancel');
							  that.searchButton()
							},
							
						});
					}
					else {
						that.$message.success('编辑成功');
						that.searchButton()
					}
					
				}).catch(err=>{
					that.confirmLoading = false
				})
			}
			
		},
		// 编辑弹窗取消
		editModalCancel(){
			if(this.confirmLoading){
				return
			}
			this.edit_visible = false
		},
		// 批量设置管理员弹窗确认按钮
		plOk(){
			let that = this
			if(that.pl_select_admin.length > 0){ // 得选择管理员
				that.pl_loading = true
				let a_data = []
				that.pl_select_admin.forEach(res=>{
					a_data.push(res.key)
				})
				console.log("a_data",a_data);
				
				let i_data = []
				that.selectedData.forEach(res=>{
					i_data.push(res.id)
				})
				console.log("i_data",i_data);
				
				putGzhSetUser({
					admin_id: a_data,
					ids: i_data,
				}).then(res=>{
					that.pl_loading = false
					console.log("批量设置管理员",res);
					that.selectedData = []
					that.plCancel()
					that.$message.success('设置成功');
					that.searchButton()
				})
			}
			else {
				this.$message.warning('请先选择管理员');
			}
			
			
		},
		// 批量设置管理员弹窗取消按钮
		plCancel(){
			if(this.pl_loading){
				return 
			}
			this.pl_select_admin = []
			this.pl_modal = false
		},
		// 表格-管理员项的编辑
		setAdminShow(e){
			let that = this
			this.selectedData = []
			this.selectedData.push(e)
			console.log(e);
			e.gzh_user.forEach(res=>{
				let obj = {
					label: res.admin_name,
					key: res.admin_id
				}
				this.pl_select_admin.push(obj)
			})
			this.pl_modal = true
		},
		
		// 编辑推广平台
		editType(e){
			console.log("编辑推广平台",e);
			this.edit_modal_title = "推广平台"
			if(e.gzh_report_config){
				this.e_type_id = e.gzh_report_config.type.toString() || undefined
			}
			else {
				this.e_type_id = undefined
			}
			this.e_req_type_id = e.id
			this.edit_visible = true
		},
		// 选择推广平台
		handleChangeT(e){
			this.e_type_id = e
		}
	},
	filters: {
		tgpt(value){ // 推广平台
			// console.log("过滤器",value)
			let that = this
			let vvv = ""
			// if(value == 1){
			// 	vvv = "百度"
			// }
			// else if(value == 2){
			// 	vvv = "微博"
			// }
			// else if(value == 3){
			// 	vvv = "巨量"
			// }
			// else if(value == 4){
			// 	vvv = "快手"
			// }
			// else if(value == 0){
			// 	vvv = "未设置"
			// }
			
			return vvv
		}
	}
}
</script>

<style scoped>

</style>